// src/components/Chatbot.jsx

import React, { useState, useEffect, useRef } from "react";
import "./Chatbot.css";

export default function Chatbot() {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([
    {
      role: "system",
      content: "You are Padi, the friendly finance assistant.",
    },
  ]);
  const [input, setInput] = useState("");
  const bottomRef = useRef(null);

  // scroll down whenever msgs change
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [msgs]);

  const send = async () => {
    if (!input.trim()) return;
    const userMsg = { role: "user", content: input };
    setMsgs((m) => [...m, userMsg]);
    setInput("");

    let res;
    try {
      res = await fetch("/api/ai-chat", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // adjust if you use a different token key
          authorization: `Bearer ${localStorage.getItem(
            "supabase.auth.token"
          )}`,
        },
        body: JSON.stringify({ messages: [...msgs, userMsg] }),
      });
    } catch (networkErr) {
      console.error("Network error calling AI:", networkErr);
      setMsgs((m) => [
        ...m,
        { role: "assistant", content: "😕 Network error, please try again." },
      ]);
      return;
    }

    if (!res.ok) {
      const text = await res.text();
      console.error(`AI API returned ${res.status}:`, text);
      setMsgs((m) => [
        ...m,
        { role: "assistant", content: "😕 Something went wrong." },
      ]);
      return;
    }

    let data;
    try {
      data = await res.json();
    } catch (parseErr) {
      console.error("Failed to parse JSON from AI:", parseErr);
      setMsgs((m) => [
        ...m,
        { role: "assistant", content: "😕 Invalid server response." },
      ]);
      return;
    }

    if (data.error) {
      console.error("AI error payload:", data.error);
      setMsgs((m) => [
        ...m,
        { role: "assistant", content: "😕 Something went wrong." },
      ]);
    } else if (data.message) {
      setMsgs((m) => [...m, data.message]);
    } else {
      console.error("Unexpected AI response:", data);
      setMsgs((m) => [
        ...m,
        { role: "assistant", content: "😕 Unexpected response." },
      ]);
    }
  };

  return (
    <div className={`chatbot-container ${open ? "open" : ""}`}>
      <button
        className="chatbot-toggle"
        onClick={() => setOpen((o) => !o)}
        aria-label={open ? "Close chat" : "Open chat"}
      >
        💬
      </button>
      {open && (
        <div className="chatbot-window">
          <div className="chatbot-messages">
            {msgs.map((m, i) => (
              <div key={i} className={`msg ${m.role}`}>
                {m.content}
              </div>
            ))}
            <div ref={bottomRef} />
          </div>
          <div className="chatbot-input">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && send()}
              placeholder="Ask me about your finances…"
            />
            <button onClick={send}>Send</button>
          </div>
        </div>
      )}
    </div>
  );
}
